// Inline follow-ups list inside the CRM Edit modal — quick add (kind+note),
// toggle done, delete. The richer "Log Interaction" form lives in CRMPreview.
import React, { useState } from "react";
import { MessageCircle, Plus, Check, Trash2 } from "lucide-react";
import { FOLLOWUP_KINDS } from "./constants";

export default function FollowUpsList({ items, onChange, title = "FOLLOW-UPS" }) {
  const [kind, setKind] = useState("dm");
  const [note, setNote] = useState("");
  const add = () => {
    if (!note.trim()) return;
    const next = [...(items || []), {
      id: `f_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`,
      kind, note: note.trim(),
      date: new Date().toISOString(),
      done: false,
    }];
    onChange(next);
    setNote("");
  };
  const toggle = (id) => onChange(items.map(it => it.id === id ? { ...it, done: !it.done } : it));
  const del = (id) => onChange(items.filter(it => it.id !== id));
  const sorted = [...(items || [])].sort((a, b) => (b.date || "").localeCompare(a.date || ""));
  return (
    <div className="mt-4 pt-4" data-testid="crm-followups">
      <div className="overline mb-2 flex items-center gap-2">
        <MessageCircle size={12} /> {title} · {items?.length || 0}
      </div>
      <div className="flex gap-2 mb-3 flex-wrap">
        {FOLLOWUP_KINDS.map(k => {
          const Icon = k.icon;
          return (
            <button key={k.v} onClick={() => setKind(k.v)} type="button"
              data-testid={`crm-fu-kind-${k.v}`}
              className={`px-2.5 py-1.5 text-[11px] font-mono-ui uppercase tracking-wider border inline-flex items-center gap-1.5 ${kind === k.v ? "border-[color:var(--gio-primary)] text-[color:var(--gio-primary)] bg-[color:var(--gio-primary)]/10" : "border-zinc-800 text-zinc-500 hover:text-white"}`}>
              <Icon size={11} /> {k.label}
            </button>
          );
        })}
      </div>
      <div className="flex gap-2 mb-3">
        <input value={note} onChange={(e) => setNote(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }}
          placeholder="What was the action? (Enter to add)"
          data-testid="crm-fu-note" className="gf-input flex-1" />
        <button onClick={add} type="button" data-testid="crm-fu-add" className="btn-primary text-xs">
          <Plus size={12} className="inline mr-1" /> Log
        </button>
      </div>
      <div className="space-y-1.5 max-h-[260px] overflow-y-auto">
        {sorted.map(f => {
          const k = FOLLOWUP_KINDS.find(x => x.v === f.kind) || FOLLOWUP_KINDS[0];
          const Icon = k.icon;
          return (
            <div key={f.id} className="flex items-start gap-2 px-2 py-1.5 border border-zinc-900 rounded text-sm" data-testid={`crm-fu-${f.id}`}
              style={{ background: f.done ? "rgba(20,184,166,0.05)" : "transparent" }}>
              <button onClick={() => toggle(f.id)} type="button" data-testid={`crm-fu-toggle-${f.id}`}
                className="mt-0.5 w-4 h-4 rounded border flex items-center justify-center"
                style={{ borderColor: f.done ? "var(--gio-secondary)" : "var(--gio-border)" }}>
                {f.done && <Check size={11} style={{ color: "var(--gio-secondary)" }} />}
              </button>
              <Icon size={12} className="mt-1 shrink-0" style={{ color: "var(--gio-secondary)" }} />
              <div className="flex-1 min-w-0">
                <div className={f.done ? "line-through text-zinc-500" : "text-white"}>{f.note}</div>
                <div className="text-[10px] mt-0.5" style={{ color: "var(--gio-muted-3)" }}>
                  {(f.date || "").slice(0, 10)} · {k.label}
                </div>
              </div>
              <button onClick={() => del(f.id)} type="button" data-testid={`crm-fu-del-${f.id}`}
                className="text-zinc-600 hover:text-[color:var(--gio-primary)]">
                <Trash2 size={12} />
              </button>
            </div>
          );
        })}
        {(!sorted.length) && <div className="text-[12px] text-zinc-600 italic">No follow-ups yet. Log the first DM, email, call or meeting.</div>}
      </div>
    </div>
  );
}
